import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonWorkerPoolOverview } from "../../CommonComponents/CommonWorkerPoolViews";
export const InfrastructureWorkerPoolsFilteredRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.workerPools.filtered,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerPoolOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
